import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-01daf631")
const _hoisted_1 = {
  key: 0,
  class: "center padding"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("dig-ui-loader", null, null, -1)
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = { key: 1 }
const _hoisted_5 = { class: "padding" }
const _hoisted_6 = ["title"]
const _hoisted_7 = ["title"]
const _hoisted_8 = ["title"]
const _hoisted_9 = ["title"]
const _hoisted_10 = { class: "padding" }
const _hoisted_11 = { class: "big" }
const _hoisted_12 = { class: "big" }
const _hoisted_13 = { key: 0 }
const _hoisted_14 = { key: 1 }
const _hoisted_15 = { class: "center title-2" }
const _hoisted_16 = { class: "description" }
const _hoisted_17 = { class: "multiline-text" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_19 = {
  key: 2,
  class: "center padding"
}
const _hoisted_20 = /*#__PURE__*/_createElementVNode("dig-ui-loader", null, null, -1)
const _hoisted_21 = [
  _hoisted_20
]
const _hoisted_22 = { key: 3 }
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_story_form_card = _resolveComponent("story-form-card")!
  const _component_base_control_grid = _resolveComponent("base-control-grid")!
  const _component_base_report_handler = _resolveComponent("base-report-handler")!
  const _component_base_card = _resolveComponent("base-card")!
  const _component_base_container = _resolveComponent("base-container")!

  return (_openBlock(), _createBlock(_component_base_container, {
    marginTop: "",
    marginBottom: "",
    class: "view-story"
  }, {
    default: _withCtx(() => [
      (_ctx.story)
        ? (_openBlock(), _createBlock(_component_base_card, {
            key: 0,
            class: "story-card"
          }, {
            default: _withCtx(() => [
              (_ctx.loadingStory)
                ? (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_3))
                : _createCommentVNode("", true),
              (!_ctx.loadingStory)
                ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                    _createVNode(_component_base_control_grid, { sideWidth: 160 }, {
                      right: _withCtx(() => [
                        _createElementVNode("div", _hoisted_5, [
                          (_ctx.canDelete && !_ctx.editing)
                            ? (_openBlock(), _createElementBlock("dig-ui-icon", {
                                key: 0,
                                type: "delete",
                                class: "icon-button",
                                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.deleteStory())),
                                title: _ctx.$t('delete')
                              }, null, 8, _hoisted_6))
                            : _createCommentVNode("", true),
                          (_ctx.canDelete)
                            ? (_openBlock(), _createElementBlock("dig-ui-icon", {
                                key: 1,
                                type: "add",
                                class: "icon-button",
                                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.informCustomers())),
                                title: _ctx.$t('informCustomers')
                              }, null, 8, _hoisted_7))
                            : _createCommentVNode("", true),
                          (_ctx.canEdit && !_ctx.editing)
                            ? (_openBlock(), _createElementBlock("dig-ui-icon", {
                                key: 2,
                                type: "edit",
                                class: "icon-button",
                                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.editing = true)),
                                title: _ctx.$t('edit')
                              }, null, 8, _hoisted_8))
                            : _createCommentVNode("", true),
                          (_ctx.canEdit && _ctx.editing)
                            ? (_openBlock(), _createElementBlock("dig-ui-icon", {
                                key: 3,
                                type: "close",
                                class: "icon-button",
                                onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.editing = false)),
                                title: _ctx.$t('cancel')
                              }, null, 8, _hoisted_9))
                            : _createCommentVNode("", true)
                        ])
                      ]),
                      left: _withCtx(() => [
                        _createElementVNode("div", _hoisted_10, [
                          _createElementVNode("dig-ui-badge", _hoisted_11, _toDisplayString(_ctx.story.points) + " points", 1),
                          _createElementVNode("dig-ui-badge", _hoisted_12, _toDisplayString(_ctx.date), 1)
                        ])
                      ]),
                      middle: _withCtx(() => [
                        (_ctx.editing)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                              _createVNode(_component_story_form_card, {
                                class: "form",
                                title: _ctx.$t('editStory'),
                                onValidate: _cache[4] || (_cache[4] = ($event: any) => (_ctx.updateStory($event))),
                                onCancel: _cache[5] || (_cache[5] = ($event: any) => (_ctx.editing = false)),
                                disabled: _ctx.disabledFormButton,
                                story: _ctx.story
                              }, null, 8, ["title", "disabled", "story"])
                            ]))
                          : _createCommentVNode("", true),
                        (!_ctx.editing)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                              _createElementVNode("dig-ui-title", _hoisted_15, " Mise à jour " + _toDisplayString(_ctx.story.name), 1)
                            ]))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    })
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_16, [
                _createElementVNode("p", _hoisted_17, _toDisplayString(_ctx.story.description), 1)
              ]),
              _hoisted_18,
              (_ctx.loadingReport)
                ? (_openBlock(), _createElementBlock("div", _hoisted_19, _hoisted_21))
                : _createCommentVNode("", true),
              (!_ctx.loadingReport)
                ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                    _createVNode(_component_base_report_handler, {
                      report: _ctx.report,
                      onLoad: _cache[6] || (_cache[6] = ($event: any) => (_ctx.loadReport($event))),
                      onDelete: _cache[7] || (_cache[7] = ($event: any) => (_ctx.deleteReport())),
                      onDownload: _cache[8] || (_cache[8] = ($event: any) => (_ctx.downloadReport()))
                    }, null, 8, ["report"])
                  ]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}